export enum ImpactPointTypes {
	FRONT = 'FRONT',
	FRONT_R = 'FRONT_R',
	FRONT_L = 'FRONT_L',
	REAR = 'REAR',
	REAR_R = 'REAR_R',
	REAR_L = 'REAR_L',
	REAR_R_INT = 'REAR_R_INT',
	REAR_L_INT = 'REAR_L_INT',
	REAR_WINDOW = 'REAR_WINDOW',
	SIDE_FRONT_L = 'SIDE_FRONT_L',
	SIDE_FRONT_R = 'SIDE_FRONT_R',
	SIDE_REAR_R = 'SIDE_REAR_R',
	SIDE_REAR_L = 'SIDE_REAR_L',
	REAR_SEAT = 'REAR_SEAT',
	REAR_SEAT_L = 'REAR_SEAT_L',
	REAR_SEAT_R = 'REAR_SEAT_R',
	REAR_BACK = 'REAR_BACK',
	REAR_BACK_L = 'REAR_BACK_L',
	REAR_BACK_R = 'REAR_BACK_R',
	MIDDLE_SEAT = 'MIDDLE_SEAT',
	MIDDLE_SEAT_L = 'MIDDLE_SEAT_L',
	MIDDLE_SEAT_R = 'MIDDLE_SEAT_R',
	MIDDLE_BACK = 'MIDDLE_BACK',
	MIDDLE_BACK_L = 'MIDDLE_BACK_L',
	MIDDLE_BACK_R = 'MIDDLE_BACK_R',
	FRONT_SEAT = 'FRONT_SEAT',
	FRONT_SEAT_L = 'FRONT_SEAT_L',
	FRONT_SEAT_R = 'FRONT_SEAT_R',
	FRONT_BACK = 'FRONT_BACK',
	FRONT_BACK_L = 'FRONT_BACK_L',
	FRONT_BACK_R = 'FRONT_BACK_R',
	WINDSHIELD = 'WINDSHIELD',
	ROOF = 'ROOF',
	body_repair = 'body_repair',
	find_from_theft = 'find_from_theft',
	lost_key = 'lost_key',
	FRONT_HOOD = 'FRONT_HOOD',
	BACK_HOOD = 'BACK_HOOD',
	INTERIOR = 'INTERIOR',
}
